import React, { useEffect, useMemo, useState } from "react";
import {
  buildPhoneValue,
  COUNTRY_DIAL_CODES,
  DEFAULT_DIAL_CODE,
  parsePhoneValue,
  sanitizeDigits,
} from "../utils/phoneUtils";

const PhoneInput = ({
  id,
  name,
  value,
  onChange,
  required,
  disabled,
  placeholder,
  autoComplete,
  className,
  inputClassName,
  selectClassName,
  defaultDialCode = DEFAULT_DIAL_CODE,
  countryLabel = "Country code",
  numberLabel = "Phone number",
}) => {
  const normalizedValue = typeof value === "string" ? value : "";
  const parsed = useMemo(
    () => parsePhoneValue(normalizedValue, defaultDialCode),
    [defaultDialCode, normalizedValue]
  );
  const [dialCode, setDialCode] = useState(parsed.dialCode);

  useEffect(() => {
    if (normalizedValue) {
      setDialCode(parsed.dialCode);
    }
  }, [normalizedValue, parsed.dialCode]);

  const handleDialCodeChange = (event) => {
    const nextCode = sanitizeDigits(event.target.value);
    setDialCode(nextCode);
    if (onChange) {
      onChange(buildPhoneValue(nextCode, parsed.nationalNumber));
    }
  };

  const handleNumberChange = (event) => {
    const digits = sanitizeDigits(event.target.value);
    const maxLength = Math.max(0, 15 - dialCode.length);
    const trimmed = digits.slice(0, maxLength);
    if (onChange) {
      onChange(buildPhoneValue(dialCode, trimmed));
    }
  };

  const maxLength = Math.max(0, 15 - dialCode.length);

  return (
    <div className={className}>
      <div className="phone-select">
        <span className="phone-select__display">{`+${dialCode}`}</span>
        <select
          id={id ? `${id}-country` : undefined}
          name={name ? `${name}Country` : undefined}
          className={selectClassName}
          value={dialCode}
          onChange={handleDialCodeChange}
          disabled={disabled}
          aria-label={countryLabel}
        >
          {COUNTRY_DIAL_CODES.map((option) => (
            <option key={option.code} value={option.code}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <input
        id={id}
        name={name}
        type="tel"
        inputMode="numeric"
        pattern="[0-9]*"
        className={inputClassName}
        value={parsed.nationalNumber}
        onChange={handleNumberChange}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        placeholder={placeholder}
        aria-label={numberLabel}
        maxLength={maxLength}
      />
    </div>
  );
};

export default PhoneInput;
